/**
 * "Change to Type 2" dalam popup pelanggan Flow Ultra (2026-09-29, keputusan user).
 *
 * Pelanggan manual Jenis 1 yang bertukar ke Jenis 2 dengan BAYARAN YANG SAMA.
 * Rekod flow_tenants yang sama DIUBAH (bukan rekod baharu) — supaya Dashboard
 * admin (jualanManualFlow) tidak mengira jualan dua kali. paidAt / priceSen /
 * startedAt asal TIDAK disentuh.
 *
 * ⚠️ KEMBAR: langkah sama seperti hantarBorang (Add customer, jenis 2) dalam
 * FlowUltraTab.jsx — server (tetapAksesJenis2) DAHULU, baru rekod pelanggan.
 * Ubah satu → semak yang lain.
 */
import { useState } from 'react';
import { Btn } from '../design/ui';
import { kemasLangganan } from '../services/flowLanggananService';
import { tetapAksesJenis2 } from '../services/flowT2Admin';

const EMEL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const isoOf = (d) => d ? `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}` : '';
const tarikh = (s) => { const b = String(s || '').split('-').map(Number); const d = b.length === 3 ? new Date(b[0], b[1] - 1, b[2]) : null; return d && !Number.isNaN(d.getTime()) ? d : null; };

export default function FlowTukarJenis2({ customer, onDone, label, produkJenis2 = [] }) {
    // Produk Type 2 yang dilekatkan pada langganan (yang pertama aktif; tiada produk → kosong).
    const produkId = produkJenis2[0]?.id || '';
    const [buka, setBuka] = useState(false);
    const [gmail, setGmail] = useState('');
    const [tamat, setTamat] = useState(isoOf(customer.expiresAt));
    const [had, setHad] = useState('');
    const [sedang, setSedang] = useState(false);
    const [ralat, setRalat] = useState('');

    // Hanya pelanggan manual Jenis 1 — pembeli Billplz (flow_subs) tidak boleh ditulis client.
    if (!customer.manual || customer.jenis === 2) return null;

    if (!buka) {
        return (
            <div>
                <p className="s-kv__lab">Product</p>
                <div className="s-kv__box">
                    {label || 'Type 1 — Lite LP only'}
                    <span style={{ marginLeft: 'auto' }}>
                        <Btn size="sm" variant="ghost" onClick={() => setBuka(true)}>Change to Type 2</Btn>
                    </span>
                </div>
            </div>
        );
    }

    const simpan = async () => {
        setRalat('');
        const email = (customer.email || '').trim().toLowerCase();
        const g = gmail.trim().toLowerCase();
        const akhir = tarikh(tamat);
        const n = Math.round(Number(had));
        const kini = new Date();
        if (!EMEL.test(email)) { setRalat('Save the customer\'s SESAAT account email above first.'); return; }
        if (!EMEL.test(g)) { setRalat('Enter the Gmail given to this customer.'); return; }
        if (!akhir) { setRalat('Pick the family renewal date.'); return; }
        if (akhir <= kini) { setRalat('The family renewal date must be in the future.'); return; }
        if (!Number.isSafeInteger(n) || n <= 0) { setRalat('Enter a credit limit.'); return; }

        setSedang(true);
        try {
            // Credit dikira mulai HARI INI — penggunaan Gmail itu sebelum pertukaran bukan milik pelanggan ini.
            const { vaultId } = await tetapAksesJenis2({ email, gmail: g, startedAt: kini, expiresAt: akhir, had: n });
            try {
                await kemasLangganan(customer, { keJenis2: { accountEmail: g, hadKredit: n, expiresAt: akhir.getTime(), productId: produkId || null } });
            } catch (e) {
                // Akses server SUDAH aktif tetapi rekod senarai belum berubah — katakan dengan jelas.
                throw new Error(`Type 2 access is ON, but the customer list was not updated (${e?.code || e?.message || 'unknown error'}). Press Save again.`);
            }
            onDone?.(vaultId);
        } catch (e) {
            setRalat(e?.message || 'Could not change to Type 2.');
        } finally {
            setSedang(false);
        }
    };

    return (
        <div className="fu-pickbox" style={{ display: 'grid', gap: 10 }}>
            <div>
                <p className="s-kv__lab">Change to Type 2 — same payment</p>
                <p className="s-kv__hint" style={{ marginTop: 0 }}>
                    Keeps this customer&rsquo;s original payment, so the dashboard still counts one sale.
                    Uses the SESAAT email above. Credits are counted from today.
                </p>
            </div>
            <div>
                <p className="s-kv__lab">Gmail given to this customer</p>
                <input className="s-inp" inputMode="email" value={gmail} maxLength={254}
                    onChange={(e) => setGmail(e.target.value)} />
            </div>
            <div className="s-kv">
                <div>
                    <p className="s-kv__lab">Family renews on (access ends)</p>
                    <input className="s-inp" type="date" value={tamat} onChange={(e) => setTamat(e.target.value)} />
                </div>
                <div>
                    <p className="s-kv__lab">Credit limit</p>
                    <input className="s-inp" inputMode="numeric" value={had} placeholder="4500"
                        onChange={(e) => setHad(e.target.value)} />
                </div>
            </div>
            {ralat && <p style={{ color: 'var(--s-stop)', fontSize: 13, margin: 0 }}>{ralat}</p>}
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
                <Btn size="sm" variant="quiet" onClick={() => { setBuka(false); setRalat(''); }} disabled={sedang}>Cancel</Btn>
                <Btn size="sm" onClick={simpan} disabled={sedang}>{sedang ? 'Saving…' : 'Save'}</Btn>
            </div>
        </div>
    );
}
